import { Box } from '@fivehealth/botero';

const TableCellItem = (props) => <Box flex="0.5" pl={2} {...props} />;
export default TableCellItem;
